import Hub from "@/features/hub/Hub";
import { parseCustomerId } from "@/features/hub/customerPath";
import { createFileRoute, notFound, rootRouteId } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId")({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        if (!parseCustomerId(params.customerId)) {
            throw notFound({ routeId: rootRouteId });
        }
    },
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    const { customerId } = Route.useParams();
    const parsedCustomerId = parseCustomerId(customerId);

    if (!parsedCustomerId) {
        throw notFound({ routeId: rootRouteId });
    }

    return <Hub customerId={parsedCustomerId} />;
}
